/**
 * The logged-in session as kept in localStorage. Everything that reads or
 * clears it goes through here so a logout (manual or forced by an expired
 * token) always removes all of it.
 */

export const ACCESS_TOKEN_KEY = "origo_access_token";
export const REFRESH_TOKEN_KEY = "origo_refresh_token";
export const USER_KEY = "user";

export const LOGIN_PATH = "/logga-in";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const clearSession = () => {
	localStorage.removeItem(ACCESS_TOKEN_KEY);
	localStorage.removeItem(REFRESH_TOKEN_KEY);
	localStorage.removeItem(USER_KEY);
};

export const isOnLoginPage = () => window.location.pathname === LOGIN_PATH;

/** Full reload, so no in-memory state (query cache, stores) survives the logout */
export const redirectToLogin = () => {
	if (!isOnLoginPage()) window.location.href = LOGIN_PATH;
};
